import classNames from "classnames";
import { memo } from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import { CellContextWithDragHandle } from "@design-system/ViewTable/ViewTable";
import { DragHandle6DotIcon } from "@icons";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { HStack } from "@design-system/HStack/HStack";
import { OrganizationCloseStageRow } from "../organizationCloseStagesViewConfig";

interface OrganizationCloseStageActionsCallbacks {
    onEditCloseStage: (closeStageId: string) => void;
    onDeleteCloseStage: (closeStageId: string) => void;
}

type OrganizationCloseStageActionsMeta = ViewTableMeta<
    OrganizationCloseStageActionsCallbacks,
    never
>;

export const OrganizationCloseStageActionsCell = memo(
    ({
        row,
        table,
        rowDragHandle,
    }: CellContextWithDragHandle<OrganizationCloseStageRow, string>) => {
        const meta = (table.options.meta ??
            {}) as OrganizationCloseStageActionsMeta;
        const closeStage = row.original;

        if (
            !meta.callbacks?.onEditCloseStage ||
            !meta.callbacks?.onDeleteCloseStage
        ) {
            return null;
        }

        return (
            <ViewTableCell captureClicks>
                <HStack align="center" justify="end" gap={12}>
                    <span
                        className={classNames(
                            "d-inline-flex",
                            "align-items-center",
                            viewTableStyles.showOnHover,
                        )}
                        {...(rowDragHandle?.attributes ?? {})}
                        {...(rowDragHandle?.listeners ?? {})}
                        onClick={(event) => event.stopPropagation()}
                    >
                        <DragHandle6DotIcon />
                    </span>
                    <Menu.More className={viewTableStyles.showOnHover}>
                        <Menu.Item
                            onClick={() =>
                                meta.callbacks?.onEditCloseStage(closeStage.id)
                            }
                        >
                            Edit
                        </Menu.Item>
                        <Menu.Item
                            destructive
                            onClick={() =>
                                meta.callbacks?.onDeleteCloseStage(
                                    closeStage.id,
                                )
                            }
                        >
                            Delete
                        </Menu.Item>
                    </Menu.More>
                </HStack>
            </ViewTableCell>
        );
    },
);
